import { useCallback, useEffect, useState, RefObject } from 'react';

export const useMaxScrollPercentage = (
  elementRef?: RefObject<HTMLElement>,
  articleId?: string
): [number, boolean] => {
  const [maxScrollPercentage, setMaxScrollPercentage] = useState(0);
  const [isScrollable, setIsScrollable] = useState(true);

  const handleScroll = useCallback(() => {
    let newScrollPercentage = 0;

    if (elementRef?.current) {
      const element = elementRef.current;
      const scrollTop = element.scrollTop;
      const scrollHeight = element.scrollHeight;
      const clientHeight = element.clientHeight;

      if (scrollHeight > clientHeight) {
        newScrollPercentage = Math.round(
          Math.min((scrollTop / (scrollHeight - clientHeight)) * 100, 100)
        );
      }
    } else {
      const footerHeight: number =
        document.querySelector('footer')?.scrollHeight || 0;
      newScrollPercentage = Math.round(
        Math.min(
          (window.scrollY /
            (document.body.scrollHeight - window.innerHeight - footerHeight)) *
          100,
          100
        )
      );
    }

    if (newScrollPercentage > maxScrollPercentage) {
      setMaxScrollPercentage(newScrollPercentage);
    }
  }, [maxScrollPercentage, elementRef]);

  useEffect(() => {
    const targetElement = elementRef?.current;

    if (targetElement) {
      targetElement.addEventListener('scroll', handleScroll);
      return () => {
        targetElement.removeEventListener('scroll', handleScroll);
      };
    } else {
      document.addEventListener('scroll', handleScroll);
      return () => {
        document.removeEventListener('scroll', handleScroll);
      };
    }
  }, [handleScroll, elementRef, articleId]);

  useEffect(() => {
    if (articleId) {
      setMaxScrollPercentage(0);
    }
    if (elementRef?.current) {
      const element = elementRef.current;
      const scrollHeight = element.scrollHeight;
      const clientHeight = element.clientHeight;
      const scrollable = scrollHeight > clientHeight;

      setIsScrollable(scrollable);
    }
  }, [articleId, elementRef]);

  return [maxScrollPercentage, isScrollable];
};
